import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "note-to-sender-container slide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header-note" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slider-title" }, "Note to the Sender")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "slide-content-note" }
const _hoisted_4 = { class: "receiver-information" }
const _hoisted_5 = {
  key: 0,
  class: "sender-note"
}
const _hoisted_6 = { class: "sender-note__heading" }
const _hoisted_7 = { class: "sender-note__note" }
const _hoisted_8 = { class: "sender-location" }
const _hoisted_9 = { class: "sender-location__heading" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Location (Details sent after payment)")
const _hoisted_11 = {
  key: 0,
  class: "description"
}
const _hoisted_12 = {
  key: 1,
  class: "description"
}
const _hoisted_13 = {
  key: 2,
  class: "description"
}
const _hoisted_14 = { class: "line" }
const _hoisted_15 = {
  key: 3,
  class: "description"
}
const _hoisted_16 = {
  key: 4,
  class: "description"
}
const _hoisted_17 = { class: "sender-response" }
const _hoisted_18 = { class: "sender-response__note flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($props.invite.note != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, "Note from " + _toDisplayString($props.person.name.fullName) + ":", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, _toDisplayString($props.invite.note), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            ($props.request?.location?.type == 'video')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Video Link"))
              : ($props.request?.location?.type == 'phone')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Phone Number"))
                : ($props.request?.location?.type == 'physical')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString($props.request.location.fields.city) + "," + _toDisplayString($props.request.location.fields.state), 1 /* TEXT */)
                    ]))
                  : ($props.request?.location?.type == 'other')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Instructions Provided"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, "No Location information provided"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, "Your note to " + _toDisplayString($props.person.name.firstName) + " about the meeting.", 1 /* TEXT */),
        _createVNode($setup["TextField"], {
          class: "sender-response__text",
          label: "Personal Note",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.message) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", { class: "button-container" }, [
      _createElementVNode("button", {
        class: "borderless sender-buttons__back",
        onClick: $setup.previous
      }, "Back"),
      _createElementVNode("button", {
        class: "borderless sender-buttons__next",
        onClick: $setup.proceed
      }, "Next")
    ])
  ]))
}